import React, { useMemo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchDBUDataWithFiltersData } from 'service/service';
import { QueryRule } from 'utils/adb-common-util';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';

/**
 * TopSpendTable component refactored to use AdbFlatTableBase.
 */
const TopSpendTable = () => {
  const location = useLocation();
  const navState = location.state;

  // Derive initial filters: Remove First (ID) and Last (Compute Type) fields by 
  // explicitly providing only the Workspace Name field.
  const initialFilters: QueryRule[] = useMemo(() => {
    const wsName = navState?.workspaceName || (navState?.contentName === 'all' ? 'All' : navState?.contentName);
    return [
      { id: '1', operator: 'AND' as const, field: 'Workspace Name', value: wsName }
    ];
  }, [navState]);

  const serviceFunc = useCallback((params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, selectedDateInString, exportType,
      sortBy, sortDir
    } = params;
    return fetchDBUDataWithFiltersData({
      startDate,
      endDate,
      env,
      sector,
      location,
      page,
      pageSize,
      filters: apiFilters,
      selectedDateInString,
      workspaceName: undefined,
      exportType,
      sortField: sortBy,
      sortOrder: sortDir
    });
  }, []);

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Top Spend"
      breadcrumbLabel="Databricks Analysis"
      breadcrumbPath="/databricksADB/workspace"
      tableType="top-spend-table"
      preserveFilterKey="top_spend_table"
      initialFilters={initialFilters}
    />
  );
};

export default TopSpendTable;